import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrModerationRecommendedAction.ts
var t = () => e("moderationRecommendedAction");
//#endregion
export { t as useTrModerationRecommendedAction };
